export function normalizeGeneratedFileContent(value) {
  const content = String(value || '')
  if (content.split('\n').length <= 2 && (content.match(/\\n/g) || []).length >= 2) {
    return content.replace(/\\r\\n/g, '\n').replace(/\\n/g, '\n').replace(/\\t/g, '\t')
  }
  return content
}

export function isUsableHtmlPreview(value) {
  const content = normalizeGeneratedFileContent(value).trim()
  if (!content) return false
  if ((content.match(/\\n/g) || []).length >= 2 && !content.includes('<')) return false
  return /<!doctype|<html[\s>]|<body[\s>]|<main[\s>]|<div[\s>]|<section[\s>]|<h1[\s>]|<script[\s>]/i.test(
    content,
  )
}
